module.exports = __webpack_public_path__ + "img/ics_o_edit_red.74647a09.svg";